<template>
  <div class="c-progress">
    <template v-if="percent >= 0 && percent < 100">
      <img class="logo" :src="images.logo_white" />
      <a-progress
        class="progress"
        :stroke-color="{
          '0%': '#4136f1',
          '100%': '#8743ff',
        }"
        :percent="percent"
        status="active"
      />
      <div class="progress-text">
        {{ text }}
      </div>
    </template>
    <template v-if="percent >= 100">
      <img class="successful-image" :src="image || images.updated_keyboard" />
      <div class="successful-text">{{ text }}</div>
      <div class="button" @click="$emit('close')">
        {{ $t("back") }}
      </div>
    </template>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "CProgress",
  props: {
    percent: Number,
    text: String,
    image: String,
  },
  computed: {
    ...mapState("app", {
      language: "language",
      isCN: "isCN",
    }),
    ...mapState("assets", {
      images: "images",
    }),
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.c-progress {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 150px;
  position: fixed;
  left: 0;
  top: 0;
  background: #171717;
  z-index: 2000;

  .logo {
    width: 300px;
    height: auto;
    margin-bottom: 60px;
  }

  .progress {
    width: 780px;
    margin-bottom: 50px;
  }

  .progress-text {
    font-size: 36px;
  }

  .successful-image {
    height: 500px;
    margin-bottom: 50px;
    margin-top: 50px;
  }

  .successful-text {
    font-size: 30px;
    margin-bottom: 50px;
  }

  .button {
    @include linear-button;
    width: 480px;
    height: 80px;
    line-height: 80px;
    margin-bottom: 60px;
  }
}
</style>

<style lang="scss">
.c-progress {
  .progress {
    .ant-progress-inner {
      overflow: visible;
      background-color: transparent;
      background-image: linear-gradient(270deg, #8743ff44 0%, #4136f144 100%);
    }
    .ant-progress-text {
      width: 0px;
      color: $primary-color;
      font-size: 28px;
    }
    .ant-progress-bg {
      position: relative;

      &::after {
        display: block;
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -10px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: $primary-color;
      }
    }
  }
}
</style>
